<template lang="pug">
.v-map.map(v-if="items")
	yandex-map.map__yandex-map(
		@map-was-initialized="map => this.mapInst = map"
		:show-all-markers="active ? false : items.length > 1"
		:coords="active?.coords || items[0]?.coords"
		:controls="['geolocationControl']"
		:zoom="zoom"
		:cluster-options="{default: {clusterDisableClickZoom: false,  clusterIconContentLayout: clusterIconContent, clusterIcons: [{ size: [50, 50], offset: [-32, -32],}]}}"
		:settings="settings",
		:options="{maxZoom: 21}")
		template(v-if="items && items.length")
			template(v-for="(item, index) in items" :key="index")
				ymap-marker(
					:markerId="item.id"
					:icon="pointIcon[index]"
					:coords="item.coords"
					:cluster-name="'default'"
					@click="markerClickHandler(item)")
</template>

<script>

	import { yandexMap, ymapMarker, loadYmap } from 'vue-yandex-maps'

	export default {

		components: { yandexMap, ymapMarker, loadYmap},

		props: {
			items: {
				type: Array,
				default: null
			},

			apiKey: {
				type: String,
				default: null
			}
		},

		emits: [
			'show-point'
		],

		watch: {
			apiKey(state) {
				this.settings.apiKey = state;
			}
		},

		data() {
			return {
				mapInst: null,
				clusters: [],
				active: null,
				zoom: "15",
				settings: {
					apiKey: '9fa90fbc-ce5f-4dc9-ae6d-433e0ec7338b',
					lang: 'ru_RU',
					coordorder: 'latlong',
					enterprise: false,
					version: '2.1'
				}
			}
		},

		mounted() {
			if (this.apiKey) {
				this.settings.apiKey = this.apiKey;
			}
		},

		computed: {
			clusterIconContent () {
				return `<div class="map__cluster ${this.active?.id}">{{ properties.geoObjects.length }}</div>`
			},

			pointIcon () {
				return this.items.map((item, index) => {
					const result = {
						layout: 'default#imageWithContent'
					};
					if (item?.id === this.active?.id) {
						result.contentLayout = `<div class="map__marker active"><img src="${item?.icon?.active}"></img></div>`,
						result.imageSize = [60, 60]
						result.imageOffset = [-25, -25]
					} else {
						result.contentLayout = `<div class="map__marker"><img src="${item?.icon?.src}"></img></div>`,
						result.imageSize = [50, 50]
						result.imageOffset = [-25, -25]
					}
					return result;
				});
			}
		},

		methods: {
			markerClickHandler(item) {
				this.active = item;
				this.$emit('show-point', item);
			}
		}
	}
</script>